import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CaneVarietyService from "../services/caneVarietyService";


// Add CaneVariety Start
const defaultCaneVarietyState = {
  addCaneVarietyLoading: false,
  addCaneVarietyData: null,
  addCaneVarietyError: null,
};

const addCaneVarietyData = createAsyncThunk(
  "caneVariety/add",
  async (payload) => {
    return await CaneVarietyService.createCaneVariety(payload);
  },
);

const addCaneVarietyReducer = createSlice({
  name: "addCaneVarietyData",
  initialState: defaultCaneVarietyState,
  extraReducers: (builder) => {
    builder.addCase(addCaneVarietyData.pending, (state) => {
      state.addCaneVarietyLoading = true;
    });
    builder.addCase(addCaneVarietyData.fulfilled, (state, action) => {
      state.addCaneVarietyLoading = false;
      state.addCaneVarietyData = action.payload;
      state.addCaneVarietyError = "";
    });
    builder.addCase(addCaneVarietyData.rejected, (state, action) => {
      state.addCaneVarietyLoading = false;
      state.addCaneVarietyData = null;
      state.addCaneVarietyError = action.error.message;
    });
  },
});

export const AddCaneVarietyReducer = addCaneVarietyReducer.reducer;
export const AddCaneVarietyData = addCaneVarietyData;
// Add CaneVariety End

// Update CaneVariety Start
const updateCaneVarietyState = {
  updateCaneVarietyLoading: false,
  updateCaneVarietyData: null,
  updateCaneVarietyError: null,
};

const updateCaneVariety = createAsyncThunk(
  "caneVariety/update",
  async (payload) => {
    return await CaneVarietyService.updateCaneVariety(payload);
  },
);

const updateCaneVarietyReducer = createSlice({
  name: "updateCaneVarietyReducer",
  initialState: updateCaneVarietyState,
  extraReducers: (builder) => {
    builder.addCase(updateCaneVariety.pending, (state) => {
      state.updateCaneVarietyLoading = true;
    });
    builder.addCase(updateCaneVariety.fulfilled, (state, action) => {
      state.updateCaneVarietyLoading = false;
      state.updateCaneVarietyData = action.payload;
      state.updateCaneVarietyError = "";
    });
    builder.addCase(updateCaneVariety.rejected, (state, action) => {
      state.updateCaneVarietyLoading = false;
      state.updateCaneVarietyData = null;
      state.updateCaneVarietyError = action.error.message;
    });
  },
});

export const UpdateCaneVarietyReducer = updateCaneVarietyReducer.reducer;
export const UpdateCaneVariety = updateCaneVariety;
//Update CaneVariety End

// Get CaneVariety Data List Start
const defaultCaneVarietyListData = {
  getCaneVarietyListLoading: false,
  getCaneVarietyListData: null,
  getCaneVarietyListError: null,
};

const fetchCaneVarietyList = createAsyncThunk(
  "caneVariety/caneVarietyList",
  async (payload) => {
    return await CaneVarietyService.getCaneVarietyList(payload);
  },
);

const getCaneVarietyListReducer = createSlice({
  name: "getCaneVarietyListData",
  initialState: defaultCaneVarietyListData,
  extraReducers: (builder) => {
    builder.addCase(fetchCaneVarietyList.pending, (state) => {
      state.getCaneVarietyListLoading = true;
    });
    builder.addCase(fetchCaneVarietyList.fulfilled, (state, action) => {
      state.getCaneVarietyListLoading = false;
      state.getCaneVarietyListData = action.payload;
      state.getCaneVarietyListError = "";
    });
    builder.addCase(fetchCaneVarietyList.rejected, (state, action) => {
      state.getCaneVarietyListLoading = false;
      state.getCaneVarietyListData = null;
      state.getCaneVarietyListError = action.error.message;
    });
  },
});

export const GetCaneVarietyListReducer = getCaneVarietyListReducer.reducer;
export const FetchCaneVarietyList = fetchCaneVarietyList;
// Get CaneVariety Data List End


// Delete CaneVariety Start
const defaultDeleteCaneVarietyState = {
  deleteCaneVarietyLoading: false,
  deleteCaneVarietyData: null,
  deleteCaneVarietyError: null,
};

const deleteCaneVarietyData = createAsyncThunk(
  "caneVariety/delete",
  async (canVarietyID) => {
    return await CaneVarietyService.deleteCanVariety(canVarietyID);
  },
);

const deleteCaneVarietyReducer = createSlice({
  name: "deleteCaneVarietyData",
  initialState: defaultDeleteCaneVarietyState,
  extraReducers: (builder) => {
    builder.addCase(deleteCaneVarietyData.pending, (state) => {
      state.deleteCaneVarietyLoading = true;
    });
    builder.addCase(deleteCaneVarietyData.fulfilled, (state, action) => {
      state.deleteCaneVarietyLoading = false;
      state.deleteCaneVarietyData = action.payload;
      state.deleteCaneVarietyError = "";
    });
    builder.addCase(deleteCaneVarietyData.rejected, (state, action) => {
      state.deleteCaneVarietyLoading = false;
      state.deleteCaneVarietyData = null;
      state.deleteCaneVarietyError = action.error.message;
    });
  },
});

export const DeleteCaneVarietyReducer = deleteCaneVarietyReducer.reducer;
export const DeleteCaneVarietyData = deleteCaneVarietyData;
// Delete CaneVariety End
